import { FieldData } from 'types/reportConstructor';

type ConfigRow = {
  header?: string;
  body?: { $subview: typeof pivot.views.JetView };
};

export const createCustomConfig = (): typeof pivot.views.config => {
  return class CustomConfig extends pivot.views.config {
    ready(...args: unknown[]) {
      super.ready(...args);

      if (!$$('resizer')) {
        this.addResizer();
      }
      this.eventId = webix.event($$('resizer').getNode(), 'mousedown', this.handleResizerMousedown);

      this.on(this.State.$changes, 'structure', this.changeDefaultDragMode);

      // webix bug, if you enter a value in the math editor (in the complex field)
      // and immediately drag this field and then close the config popup
      this.on(webix, 'onBeforePortletMove', this.resetFocusOnMathEditor);
    }

    destroy() {
      webix.eventRemove(this.eventId);
    }

    config() {
      const config = super.config();

      config.rows[1]?.body?.rows?.forEach((row: ConfigRow, rowIndex: number) => {
        if (row.header?.includes('Table')) {
          config.rows[1].body.rows.splice(rowIndex, 1);
        } else if (row.header?.includes('Filters')) {
          const filtersView = row.body?.$subview;

          if (filtersView) {
            const filterSuggest = filtersView.FilterSuggest;

            filtersView.FilterSuggest = (...args: unknown[]) => {
              const [, , field] = args;
              if (!(field as FieldData).usedInFilters) {
                return false;
              }
              return filterSuggest(...args);
            };
          }
        }
      });

      return config;
    }

    private changeDefaultDragMode = () => {
      const formItems = this.getRoot()?.queryView({ view: 'pivot-portlet' }, 'all') ?? [];

      for (const formItem of formItems) {
        formItem.define('mode', 'rows');
      }
    };

    private addResizer = () => {
      const configView = this.getRoot()?.getParentView();
      const parentView = configView?.getParentView();

      if (parentView) {
        parentView.addView({ view: 'resizer', id: 'resizer' }, 1);

        configView.define('width', configView.config.maxWidth);
        configView.define('maxWidth', undefined);
      }
    };

    private handleResizerMousedown = () => {
      // webix bug, if you enter a value in the math editor (in the complex field)
      // and immediately start moving the resizer
      this.resetFocusOnMathEditor();

      webix.delay(() => {
        if (this.app) {
          this.SetValues();
          this.changeDefaultDragMode();
        }
      });
    };

    private resetFocusOnMathEditor = () => {
      const focusedView = webix.UIManager.getFocus();

      if (focusedView?.config?.name === 'math') {
        webix.UIManager.setFocus(null);
      }
    };
  };
};
